'use strict';

function Educational() {
  this.id = null;
  this.node = null;
  this.extends = [];

  this.contentType = 'educational';
  this.contentId = ''; // contentId defined in pug file

  this.elements = {};

  this.initEducational = function () {
    this.contentRef = 'content.' + this.contentType + '.' + this.contentId;
    this._product = new Product(this.contentRef, this.presenter);

    if (this._product.valid) {
      this.analytics.pushEvent('virtual-page-view');
      this._product.pushContentfulAnalyticsEvent();

      // content elements:
      this.elements.media = this.node.querySelector('.js--media');
      this.elements.primaryCta = this.node.querySelector('.js--primary-cta');
      this.elements.buttonList = this.node.querySelector('.js--button-list');

      // load required components:
      this._product.loadMedia(this.elements.media);
      this.initReadKeysCta();
      this._configureArrowAnimations();

      // load optional components:
      if (this.elements.buttonList) {
        this._product.loadButtonList(this.elements.buttonList);
      }
    } else {
      // coming soon view is displayed
    }
  };

  this.initReadKeysCta = function () {
    // wealth-education-articles
    var firstArticleId = this.presenter.getModelProperty(this.contentRef + '.articleSet.articles.0.id');
    this._product.loadPrimaryCta(this.elements.primaryCta, 'nav-action-1', this.pageAction.bind(this, firstArticleId));
  };

  this._configureArrowAnimations = function () {
    var downArrows = this.node.querySelector('.js--down-arrows');
    window.addEventListener('scroll', function () {
      downArrows.classList.remove('animate');
    }, { once: true });
  };

  this.pageAction = function (target) {
    this.history.goToUrl(location.pathname + '/articles#' + target);
  };

  this.destroyEducational = function () {
    if (this._product) {
      this._product.destroy();
    }
  };

  // Template file is not first component extended so don't use these
  this.init = function () {};

  this.initAllReady = function () {};

  this.destroy = function () {};
}